import { FileObject } from "../services/file.service";
import { apiEndpoint } from "./constants/config.constants";
import placeholder from "assets/images/placeholder.png";

export const toBase64 = (file: File) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
});

export const getImagePath = (path: string) => {
  if (path) {
    const imagePath = `${apiEndpoint}/file/assets/${path}`;
    if (imageExists(path)) {
      return imagePath;
    } else {
      return placeholder;
    }
  }
  return placeholder
}

export const getFirstFilesPath = (files: FileObject[] | FileObject) => {
  if (Array.isArray(files)) {
    return files?.[0]?.s3Url
  }
  return files?.s3Url || placeholder
}

export const getS3UrlFromFileId = (fileId: string, files?: FileObject[] | FileObject, filesType: 'file' | 'url' = 'file') => {
  if (filesType === 'url') {
    return fileId
  }

  if (Array.isArray(files)) {
    const file = files?.find((file) => file.fileId === fileId)
    return file?.s3Url || placeholder
  }

  return files?.s3Url || placeholder
}

export const imageExists = (imageUrl: string) => {

  var http = new XMLHttpRequest();

  http.open('HEAD', imageUrl, false);
  http.send();

  return http.status !== 404;

}

